import { render, staticRenderFns } from "./EventRoulette.vue?vue&type=template&id=0a5c4764&scoped=true"
import script from "./EventRoulette.vue?vue&type=script&lang=js"
export * from "./EventRoulette.vue?vue&type=script&lang=js"
import style0 from "./EventRoulette.vue?vue&type=style&index=0&id=0a5c4764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5c4764",
  null
  
)

export default component.exports